// Alisher & Muazzam — preview thumbnail. The full design at
// /templates/alisher-muazzam.html is a sage + paper wedding
// template (Italiana display, gentle olive palette). This 5:7
// thumbnail mirrors that calm botanical mood with paired sage
// stems flanking the names.

import type { LayoutCtx } from "./_shared";

export function AlisherMuazzamPreviewLayout({ names, date, venue, ink, bg, font }: LayoutCtx) {
  const [a, b] = names.split(/\s*&\s*/);
  const sage = "#6B8459";
  const sageSoft = "#C4D1B0";
  const gold = "#B89B5E";
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(180deg, ${bg} 0%, #DCE3CF 100%)`,
        color: ink,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "10% 8%",
      }}
    >
      {/* Sage stem on left */}
      <svg aria-hidden viewBox="0 0 60 80" style={{ position: "absolute", top: "18%", left: "8%", width: "16%", height: "auto", color: sage, opacity: 0.85 }}>
        <path d="M30 78 Q 30 44 30 8" stroke="currentColor" strokeWidth="0.9" fill="none" strokeLinecap="round" />
        <ellipse cx="22" cy="62" rx="6" ry="2.2" transform="rotate(-25 22 62)" fill="currentColor" opacity="0.75" />
        <ellipse cx="38" cy="48" rx="6" ry="2.2" transform="rotate(25 38 48)" fill="currentColor" opacity="0.75" />
        <ellipse cx="22" cy="32" rx="5.4" ry="2" transform="rotate(-28 22 32)" fill="currentColor" opacity="0.7" />
        <ellipse cx="38" cy="18" rx="5.4" ry="2" transform="rotate(28 38 18)" fill="currentColor" opacity="0.7" />
      </svg>
      {/* Sage stem on right (mirrored) */}
      <svg aria-hidden viewBox="0 0 60 80" style={{ position: "absolute", top: "18%", right: "8%", width: "16%", height: "auto", color: sage, opacity: 0.85, transform: "scaleX(-1)" }}>
        <path d="M30 78 Q 30 44 30 8" stroke="currentColor" strokeWidth="0.9" fill="none" strokeLinecap="round" />
        <ellipse cx="22" cy="62" rx="6" ry="2.2" transform="rotate(-25 22 62)" fill="currentColor" opacity="0.75" />
        <ellipse cx="38" cy="48" rx="6" ry="2.2" transform="rotate(25 38 48)" fill="currentColor" opacity="0.75" />
        <ellipse cx="22" cy="32" rx="5.4" ry="2" transform="rotate(-28 22 32)" fill="currentColor" opacity="0.7" />
        <ellipse cx="38" cy="18" rx="5.4" ry="2" transform="rotate(28 38 18)" fill="currentColor" opacity="0.7" />
      </svg>

      {/* Eyebrow */}
      <div
        style={{
          fontFamily: "var(--font-ui)",
          fontSize: 7,
          fontWeight: 600,
          letterSpacing: "0.46em",
          textTransform: "uppercase",
          color: sage,
          marginBottom: 14,
        }}
      >
        Save the date
      </div>

      {/* Names */}
      <div
        style={{
          fontFamily: font,
          fontWeight: 400,
          fontSize: 28,
          color: ink,
          lineHeight: 1.0,
          letterSpacing: "0.02em",
        }}
      >
        {a ?? names}
      </div>
      <div
        style={{
          fontFamily: "'Pinyon Script', cursive",
          fontSize: 22,
          color: gold,
          margin: "2px 0",
          lineHeight: 1,
        }}
      >
        &amp;
      </div>
      <div
        style={{
          fontFamily: font,
          fontWeight: 400,
          fontSize: 28,
          color: ink,
          lineHeight: 1.0,
          letterSpacing: "0.02em",
        }}
      >
        {b ?? ""}
      </div>

      {/* Sage rule */}
      <div aria-hidden style={{ width: "40%", height: 1, background: sageSoft, margin: "16px 0 12px" }} />

      {/* Date */}
      <div
        style={{
          fontFamily: "var(--font-ui)",
          fontSize: 7.5,
          fontWeight: 600,
          letterSpacing: "0.36em",
          color: ink,
          textTransform: "uppercase",
          fontFeatureSettings: '"tnum" 1, "lnum" 1',
        }}
      >
        {date.replace(/\./g, " · ")}
      </div>
      <div style={{ fontFamily: font, fontStyle: "italic", fontSize: 11, color: ink, opacity: 0.72, marginTop: 4 }}>
        {venue}
      </div>
    </div>
  );
}
